import React, { Component } from 'react';
import "../App.css";
import { Icon } from './Icon';

// ─── ERROR BOUNDARY — prevents white screen of death ──────────────────
export class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error("App error caught:", error, info); }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"#F8F6F1", fontFamily:"system-ui,sans-serif", padding:20 }}>
          <div style={{ maxWidth:440, textAlign:"center", background:"#fff", padding:"40px 32px", borderRadius:16, boxShadow:"0 8px 30px rgba(0,0,0,0.08)" }}>
            <div style={{ marginBottom:12, color:"#B45309" }}><Icon name="warning" size={44} /></div>
            <h2 style={{ margin:"0 0 8px", color:"#0B1F3A", fontSize:20 }}>Something went wrong</h2>
            <p style={{ color:"#6B7280", fontSize:14, margin:"0 0 24px", lineHeight:1.5 }}>
              The page hit an unexpected error. Your data is safe. Please reload to continue.
            </p>
            <button onClick={() => window.location.reload()}
              style={{ background:"#0B1F3A", color:"#fff", border:"none", padding:"12px 28px", borderRadius:8, fontSize:14, fontWeight:600, cursor:"pointer" }}>
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
